<template>
  <div v-if="element" :class="`${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{...getStyles({...element.compData.styles, wrapWidth: element.boxStyle.width, wrapHeight: element.boxStyle.height})}">
    <section class="button-section" style="width:100%; height:100%;">
      <Button long
        @click.stop="handleClick($event, element)"
      class="btn-comp"
      :ghost="element.compData.styleId === 2"
      >{{ element.compData.btnTitle}}</Button>
    </section>
  </div>
</template>

<script>
// iview
import {
  Button
} from 'view-design';
import 'view-design/dist/styles/iview.css'

export default {
  name: 'CompButton',
  props: {
    element: {
      type: Object,
      default: null,
      require: true
    }
  },
  components: {
    Button
  },
  data: () => {
    return {
      loading: true
    }
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    }
  },
  mounted () {
    setTimeout(() => {
      this.loading = false
    }, 1234)
    this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: this.plugin.compData.btnTitle,
        data: this.plugin,
        event: null
      }
    })
  },
  methods: {
    handleClick (e) {
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onclick',
        eventData: {
          value: this.plugin.compData.btnTitle,
          data: this.plugin,
          event: e
        }
      })
    },
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .ivu-btn,.ivu-btn-ghost{
    margin: 0;
    height:var(--wrapHeight);
    line-height:var(--wrapHeight);
    background: var(--bgColor);
    border-color: var(--borderColor);
    border-radius: var(--borderRadius);
    border-width: var(--borderWidth);
    border-style: var(--borderStyle);
    color: var(--color);
    font-size: var(--fontSize);
    font-weight: var(--fontWeight);
    font-family: var(--fontFamily);
    box-shadow: 0 3px 6px rgba(0,0,0,.2);
    &:hover{
      background-color: var(--hoverBgColor) !important;
      border-color: var(--hoverBgColor);
      color: var(--hoverColor) !important;
      line-height: var(--wrapHeight) !important;
    }
  }
  /deep/ .ivu-btn-ghost{
        background: transparent;
        &:hover{
            background: transparent;
        }
    }
.btn-comp{
  text-align: center;
  width:100%;
  height:100%;
}
</style>
